import { Stackable } from "common/stackable/types";

/**
 * Partitions stacks by type, where each new sequence of stackables of the same type will
 * be in the same array.
 */
export const partitionStackByType = <T extends Stackable>(stack: T[]): T[][] => {
  const partitioned: T[][] = [];
  let currentStack: T[] = [];
  stack.forEach((stackable) => {
    if (!currentStack.length || stackable.type === currentStack[currentStack.length - 1].type) {
      currentStack.push(stackable);
    } else {
      partitioned.push(currentStack);
      currentStack = [stackable];
    }
  });
  if (currentStack.length) {
    partitioned.push(currentStack);
  }
  return partitioned;
};
